/**
 * Align mega-menu content under the hovered parent category link.
 * Horizon paints a full-bleed submenu; content was flush-left regardless of parent.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 990px)');
  var EDGE = 32;
  var timers = new WeakMap();

  function clusterWidth(grid) {
    var list = grid.querySelector('.mega-menu__list');
    var content = grid.querySelector('.mega-menu__content');
    if (list && content) {
      var a = list.getBoundingClientRect();
      var b = content.getBoundingClientRect();
      if (a.width > 0 && b.width > 0) {
        return Math.max(a.right, b.right) - Math.min(a.left, b.left);
      }
    }
    // Fallback: sum non-empty direct children that aren't stretching full row
    var left = Infinity;
    var right = 0;
    var kids = grid.children;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.width < 8) continue;
      // Ignore children that still span the full overlay
      if (r.width > window.innerWidth * 0.85) continue;
      left = Math.min(left, r.left);
      right = Math.max(right, r.right);
    }
    if (right > left && left !== Infinity) return right - left;

    // Last resort: offsetWidth after max-content
    return Math.min(grid.offsetWidth, window.innerWidth - EDGE * 2);
  }

  function alignItem(item) {
    if (!item || !MQ.matches) return false;
    var link = item.querySelector(':scope > .menu-list__link');
    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!link || !submenu) return false;
    var grid = submenu.querySelector('.mega-menu__grid');
    if (!grid) return false;

    var subStyle = window.getComputedStyle(submenu);
    if (subStyle.visibility === 'hidden' || subStyle.display === 'none') return false;

    grid.style.transition = 'none';
    grid.style.width = 'max-content';
    grid.style.maxWidth = '100%';
    grid.style.marginInlineStart = '0px';
    void grid.offsetWidth;

    var naturalLeft = grid.getBoundingClientRect().left;
    var width = clusterWidth(grid);
    if (width < 80) return false;

    var linkLeft = link.getBoundingClientRect().left;
    var maxLeft = window.innerWidth - width - EDGE;
    var absLeft = Math.max(EDGE, Math.min(linkLeft, maxLeft));
    var offset = absLeft - naturalLeft;

    grid.style.marginInlineStart = Math.round(Math.max(0, offset)) + 'px';
    return width < window.innerWidth * 0.85;
  }

  function schedule(link) {
    if (!link) return;
    var item = link.closest('.menu-list__list-item');
    if (!item || item.hasAttribute('slot')) return;

    var prev = timers.get(item);
    if (prev) window.clearTimeout(prev);

    var attempts = 0;
    function tryAlign() {
      attempts += 1;
      alignItem(item);
      // Re-run a few times: first paint often still has full-width grid metrics
      if (attempts < 10) {
        timers.set(item, window.setTimeout(tryAlign, 40));
      }
    }

    requestAnimationFrame(function () {
      timers.set(item, window.setTimeout(tryAlign, 20));
    });
  }

  function init() {
    var menu = document.querySelector('header-menu') || document.querySelector('.header-menu');
    if (!menu) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.getAttribute('aria-expanded') === 'true') schedule(t);
      }
    });
    menu.querySelectorAll('.menu-list__link[aria-controls]').forEach(function (link) {
      observer.observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });
    });

    menu.addEventListener(
      'pointerenter',
      function (e) {
        var link = e.target.closest && e.target.closest('.menu-list__link[aria-controls]');
        if (link) schedule(link);
      },
      true
    );

    window.addEventListener(
      'resize',
      function () {
        var open = menu.querySelector('.menu-list__link[aria-expanded="true"]');
        if (open) schedule(open);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
